var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('shop-settlement-info-card',{attrs:{"title":"업체정보","data":_vm.infos,"mt":"7"}})}
var staticRenderFns = []

export { render, staticRenderFns }